import React from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { alpha, Collapse, Paper, Stack, Typography } from '@mui/material'

type Props = {
  title: string
  icon: React.ReactNode
  color: string
  open: boolean
  onToggle: () => void
  adornments?: React.ReactNode
  children: React.ReactNode
}

// Every child of the header must be phrasing content: a button legally holds no div, p or heading.
const SectionPanel = ({ title, icon, color, open, onToggle, adornments, children }: Props) => (
  <Paper sx={{ overflow: 'hidden', borderTop: 3, borderTopColor: color }} variant="outlined">
    <Stack
      aria-expanded={open}
      component="button"
      direction="row"
      onClick={onToggle}
      sx={{
        alignItems: 'center',
        gap: 1,
        width: '100%',
        px: 2,
        py: 1.25,
        background: alpha(color, 0.07),
        border: 0,
        borderBottom: open ? 1 : 0,
        borderColor: 'divider',
        cursor: 'pointer',
        font: 'inherit',
        textAlign: 'left',
        color: 'inherit',
      }}
      type="button">
      <Stack component="span" sx={{ color, display: 'inline-flex' }}>
        {icon}
      </Stack>

      <Typography component="span" sx={{ fontWeight: 700, flexGrow: 1 }} variant="subtitle2">
        {title}
      </Typography>

      {adornments}

      {open ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />}
    </Stack>

    <Collapse in={open} mountOnEnter timeout="auto" unmountOnExit>
      {children}
    </Collapse>
  </Paper>
)

export default SectionPanel
